import { render, staticRenderFns } from "./ListItemWithBorder.vue?vue&type=template&id=9ef9e634&scoped=true&"
import script from "./ListItemWithBorder.vue?vue&type=script&lang=ts&"
export * from "./ListItemWithBorder.vue?vue&type=script&lang=ts&"
import style0 from "./ListItemWithBorder.vue?vue&type=style&index=0&id=9ef9e634&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ef9e634",
  null
  
)

export default component.exports